export default {
    lang: {
        name: 'Want to play'
    }
}